// extracted by mini-css-extract-plugin
export default {"news-card-width":"NewsComponent_news-card-width__mQG9D"};